/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface ILogoutRouteParams extends angular.route.IRouteParamsService {
        referrer: string;
    }

    interface ILogoutFrame {
        id: string,
        url: string,
        completed: boolean;
    }

    interface ILogout {
        activate: () => void;
        crossroadsLogoutUrl: string;
        logoutFrames: ILogoutFrame[];
    }

    class Logout implements ILogout {
        static controllerId: string = "logout";

        static $inject: string[] = ["config", "common", "$routeParams", "$location", "$rootScope", "$timeout", "$sce", "$window", "$uibModal", "$scope"];
        crossroadsLogoutUrl: string;
        logoutFrames: ILogoutFrame[] = [{
            id: "Crossroads",
            url: this.config.crossroadsUrl + "/application/logout?referrer=Cfnc",
            completed: false
        },
        {
            id: "rds",
            url: this.config.residencyUrl + "#/logout/rds?referrer=Cfnc",
            completed: false
        }
        ];
        logoutTimer: any;
        logError: (msg, data?, showToast?) => void;

        constructor(private config: IConfig,
            private common: ICommonFactory,
            private $routeParams: ILogoutRouteParams,
            private $location: ng.ILocationService,
            private $rootScope: ng.IRootScopeService,
            private $timeout: ng.ITimeoutService,
            private $sce: ng.ISCEService,
            private $window: ng.IWindowService,
            private $uibModal: angular.ui.bootstrap.IModalService,
            private $scope: angular.IScope) {
            this.logError = common.logger.getLogFn(Logout.controllerId, "error");

            if (!$routeParams.referrer) {
                this.common.authentication.checkLogin().then((user) => {
                    this.common.authentication.logout();
                }, (reason) => {
                    this.logError("User is not showing as logged in on the logout page", reason, false);
                    this.$window.location.href = this.config.umbracoUrl;
                });

            } else {
                if ($routeParams.referrer == "Auth") {
                    this.logoutUser();
                } else {
                    this.common.authentication.logout();
                }
            }


            this.activate();

        }

        messageReceived = (data) => {
            _.find<ILogoutFrame>(this.logoutFrames, { id: data }).completed = true;

            if (_.every(this.logoutFrames, { completed: true })) {
                this.$timeout.cancel(this.logoutTimer);
                this.logoutUser();

            }
        }

        activate() {
            this.common.activateController([], Logout.controllerId);
        }

        logoutUser(): ng.IPromise<ng.IHttpPromiseCallbackArg<any>> {
            var deferred: ng.IDeferred<any> = this.common.$q.defer();
            //this.$window.onbeforeunload = null;
            //this.$window.onkeydown = null;
            //this.common.authentication.logout(false).then(() => {
            //    deferred.resolve();
            //}, () => {
            //    deferred.reject();
            //});

            this.common.authentication.completeLogout().then(() => {
                deferred.resolve();
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
        }
    }

    angular.module("app").controller(Logout.controllerId, Logout);
}